import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SideMenu from "./components/SideMenu";
import ScreenBanner from "../../../../components/ScreenBanner";
import { ConfirmProvider } from "material-ui-confirm";
import Sazonalidade from "./Sazonalidade";
import Setores from "./Setores";
import Departamentos from "./Departamentos";
import PermissionGuard from "../../../../components/PermissionGuard";
import Compradores from "./Compradores";

export default function ConfiguracoesEstoque() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [configSelecionada, setConfigSelecionada] = useState<TConfigSelect>(
    (params.get("menu") as TConfigSelect) || "Sazonalidade"
  );

  //Funções Manipuladoras
  const handleSelectItemConfig = useCallback(
    (config: TConfigSelect) => {
      setConfigSelecionada(config);
      navigate(`/estoque/configuracoes?menu=${config}`);
    },
    [navigate]
  );

  //Valores importantes
  const renderContent = useMemo(() => {
    if (configSelecionada === "Sazonalidade") {
      return <Sazonalidade />;
    }
    if (configSelecionada === "Setores") {
      return <Setores />;
    }
    if (configSelecionada === "Departamentos") {
      return <Departamentos />;
    }
    if (configSelecionada === "Compradores") {
      return <Compradores />; 
    }
  }, [configSelecionada]);
  //

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setConfigSelecionada(
      (params.get("menu") as TConfigSelect) || "Sazonalidade"
    );
  }, [location.search]);

  return (
    <>
      <ScreenBanner title="Estoque" />
      <PermissionGuard permissionId="estoque.configuracoes">
        <Container sx={{ my: 4 }}>
          <Typography textAlign="center" variant="h5">
            Configurações do estoque
          </Typography>

          <Grid container spacing={2} mt={1}>
            <Grid size={{xs: 12, md: 4}}>
              <Box component={Paper} p={2}>
                <SideMenu
                  select={configSelecionada}
                  handleSelect={(item) => handleSelectItemConfig(item)}
                />
              </Box>
            </Grid>

            <Grid size={{xs: 12, md: 8}}>
              <Box component={Paper} p={2}>
                <ConfirmProvider
                  defaultOptions={{
                    title: "Excluir item",
                    cancellationText: "Cancelar",
                    confirmationText: "Excluir",
                    confirmationButtonProps: {
                      variant: "contained",
                      color: "error",
                    },
                  }}
                >
                  {renderContent}
                </ConfirmProvider>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </PermissionGuard>
    </>
  );
}

export type TConfigSelect = "Sazonalidade" | "Setores" | "Departamentos" | "Compradores";

export type TConfigModalState = {
  [key in TConfigSelect]: boolean;
};
